import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const cMCampaignsApi = createApi({
  reducerPath: 'cMCampaignsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Campaign'],
  endpoints: (builder) => ({
    listCampaign: builder.query({
      query: (params) => ({
        url: `/campaigns/`,
        params,
      }),
      providesTags: ['Campaign'],
    }),

    retrieveCampaign: builder.query({
      query: ({ id, params }) => ({
        url: `/campaigns/${id}/`,
        params,
      }),
      providesTags: ['Campaign'],
    }),

    createCampaign: builder.mutation({
      query: (data) => ({
        url: `/campaigns/?expand=user,last_updated_by,customer,platforms`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Campaign'],
    }),

    updateCampaign: builder.mutation({
      query: ({ id, data }) => ({
        url: `/campaigns/${id}/?expand=user,last_updated_by,customer,platforms`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Campaign'],
    }),

   
  }),
});

export const {
  useListCampaignQuery,
  useLazyListCampaignQuery,
  useRetrieveCampaignQuery,
  useCreateCampaignMutation,
  useUpdateCampaignMutation,
} = cMCampaignsApi;
